import React, { useEffect, useState } from "react";
import { Container, Typography, Button, Box, Grid2, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";
import LinkIcon from "@mui/icons-material/Link";
import { Backdrop, CircularProgress, } from "@mui/material";

const live_events_service = require('../../helpers/live_events_service')

const sponsorships = [
    {
        title: "🏆 Diamante",
        price: "$11,800",
        benefits: ["Stand de 6x2 metros", "4 cortesías para el evento", "Video promocional exclusivo"],
        color: "#f2b440",
    },
    {
        title: "🥇 Oro",
        price: "$7,800",
        benefits: ["Stand de 6x2 metros", "2 cortesías para el evento", "Publicidad en plataformas digitales"],
        color: "#f2b440",
    },
    {
        title: "🥈 Plata",
        price: "$5,800",
        benefits: ["Stand de 3x2 metros", "1 cortesía para el evento", "Logo en material promocional"],
        color: "#f2b440",
    },
];

const Patrocinio = () => {
    const [evento, setEvento] = useState(null);
    const [loading, setLoading] = useState(true);
    const [contador] = useState(0)
    useEffect(() => {
        live_events_service.getData('/evento/view-by-hash/' + process.env.REACT_APP_EVT).then((response) => {
            setEvento(response.data.response_database.result[0])
            setLoading(false)
        }).catch((error) => {
            console.log(error)
        })
    }, [contador])
    return (
        <Box
            sx={{
                color: "white",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: 4,
            }}
        >
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Container maxWidth>
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 1 }}
                >
                    <Typography variant="h3" fontWeight="bold" gutterBottom color='#272948'>
                        Congreso COPLAFT - FELABAN 2025
                    </Typography>
                    <Typography variant="h5" sx={{ marginBottom: 2 }} color='#272948'>
                        Oportunidad de patrocinio y participación en los eventos más importantes del sector financiero.
                    </Typography>
                </motion.div>
                <Grid2 container>
                    <Grid2 size={{ xs: 6, md: 6, lg: 6 }}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.8 }}
                        >
                            {evento && <Button
                                variant="contained"
                                sx={{ backgroundColor: "#f2b440", color: "white", marginBottom: 4 }}
                                startIcon={<LinkIcon />}
                                href={evento.evt_info_pdf}
                                target="_blank"
                            >
                                Más Información
                            </Button>}
                        </motion.div>
                    </Grid2>
                    <Grid2 size={{ xs: 6, md: 6, lg: 6 }}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.8 }}
                        >
                            {evento && <Button
                                variant="contained"
                                sx={{ backgroundColor: "#f2b440", color: "white", marginBottom: 4 }}
                                startIcon={<LinkIcon />}
                                href="mailto:ncuches@ebg.edu.gt?subject=Solicitud%20de%20información%20de%20patrocinio%20para%20COPLAFT&body=Buenos%20días,%0A%0ANecesito%20más%20información%20sobre%20una%20propuesta%20de%20patrocinio%20para%20COPLAFT.%0A%0AGracias."
                                target="_blank"
                            >
                                Click para solicitar más información
                            </Button>}
                        </motion.div>
                    </Grid2>
                </Grid2>
                <Typography variant="h4" fontWeight="bold" gutterBottom color='#272948'>
                    Beneficios de Patrocinio
                </Typography>

                <Grid2 container spacing={3} justifyContent="center">
                    {sponsorships.map((sponsor, index) => (
                        <Grid2 size={{ xs: 12, md: 6, lg: 4 }} key={index}>
                            <motion.div
                                whileHover={{ scale: 1.05 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                initial={{ opacity: 0, y: 50 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ duration: 0.8 }}
                            >
                                <Card sx={{ backgroundColor: sponsor.color, color: "white", borderRadius: 2 }}>
                                    <CardContent>
                                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                                            {sponsor.title}
                                        </Typography>
                                        {sponsor.benefits.map((benefit, i) => (
                                            <Typography key={i} variant="body1">
                                                - {benefit}
                                            </Typography>
                                        ))}
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid2>
                    ))}
                </Grid2>
            </Container>
        </Box>
    );
};

export default Patrocinio;
